function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isMatchingPattern } from './string.js';

/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */
function shouldIgnoreSpan(span, ignoreSpans) {
  if (!(ignoreSpans !== null && ignoreSpans !== void 0 && ignoreSpans.length) || !span.description) {
    return false;
  }
  var _iterator = _createForOfIteratorHelper(ignoreSpans),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pattern = _step.value;
      if (isStringOrRegExp(pattern)) {
        if (isMatchingPattern(span.description, pattern)) {
          return true;
        }
        continue;
      }
      if (!pattern.name && !pattern.op) {
        continue;
      }
      var nameMatches = pattern.name ? isMatchingPattern(span.description, pattern.name) : true;
      var opMatches = pattern.op ? span.op && isMatchingPattern(span.op, pattern.op) : true;

      // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
      // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
      // not both op and name actually have to match. This is the most efficient way to check
      // for all combinations of name and op patterns.
      if (nameMatches && opMatches) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
}

/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */
function reparentChildSpans(spans, dropSpan) {
  var droppedSpanParentId = dropSpan.parent_span_id;
  var droppedSpanId = dropSpan.span_id;

  // This should generally not happen, as we do not apply this on root spans
  // but to be safe, we just bail in this case
  if (!droppedSpanParentId) {
    return;
  }
  var _iterator2 = _createForOfIteratorHelper(spans),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var span = _step2.value;
      if (span.parent_span_id === droppedSpanId) {
        span.parent_span_id = droppedSpanParentId;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function isStringOrRegExp(value) {
  return typeof value === 'string' || value instanceof RegExp;
}
export { reparentChildSpans, shouldIgnoreSpan };